// components/content/types.ts

export interface ContentI {
  organization: any;
  _id: string;
  type: string;
  uniqueLinkId?: string;
  details: {
    title: string;
    tags: string[];
    description?: string;
    message?: string;
    files?: ContentFile[];   
    subject?: string;
    html?: string;
    videoUrl?: string;
    location?: any;
    address?: string;
  };
  files?: ContentFile[];   
  viewCount: number;
}

export interface Tag {
  name: string;
  value: string;
}

export interface FileWithProgress {
  name: string;
  fileName?: string;
  size: number;
  filePath?: string;
  progress?: number;
  uploaded: boolean;
  uploadFile?: File; // Add this property to support file uploads
  error?: string; // ✅ NEW: Add error property for failed uploads
}

// ✅ NEW: Enhanced ContentFile interface with required properties
export interface ContentFile {
  fileName: string; // Make this required (not optional)
  filePath: string; // Make this required (not optional)
  name?: string;
  size?: number;
  fileSize?: string;
  uploadedAt?: string;
  uploadedBy?: string;
}

// Log levels for consistent logging
export enum LogLevel {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  DEBUG = 'DEBUG'
}

// Types for content management system
export type ContentType = 'message' | 'page' | 'file' | 'email_template' | 'digital_card';

export interface ContentDetails {
  title?: string;
  tags?: string[];
  description?: string;
  message?: string;
  subject?: string;
  files?: Array<{
    fileName?: string;
    filePath?: string;
    name?: string;
  }>;
  videoUrl?: string;
  location?: any;
  address?: string;
  html?: string;
}

export interface ContentGridProps {
  contentData?: ContentI[];
  filterData: ContentI[];
  activeTab: ContentType;
  openMessageBox: boolean;
  isSearching?: boolean;
  searchError?: string | null;
  searchQuery?: string;
  setMessageData: React.Dispatch<React.SetStateAction<{
    title: string;
    tags: string[];
    message: string;
  }>>;
  setActiveId: (id: string) => void;
  setOpenMessageBox: (value: boolean) => void;
  openPageBox: boolean;
  setOpenPageBox: (value: boolean) => void;
  openFileBox: boolean;
  setOpenFileBox: (value: boolean) => void;
  openEmailBox: boolean;
  setOpenEmailBox: (value: boolean) => void;
  openDigitalCardBox?: boolean;
  setOpenDigitalCardBox?: (value: boolean) => void;
  setEmailData: (data: ContentI['details']) => void;
  setPageData: React.Dispatch<React.SetStateAction<any>>;
  setDigitalCardData?: React.Dispatch<React.SetStateAction<DigitalCardData>>;
}

export interface PageData {
  title: string;
  tags: string[];
  description: string;
  videoUrl: string;
  location: any;
  address: string;
  files: FileWithProgress[];
  uniqueLinkId?: string;
  _id?: string;
  organization?: string;
  type?: string;
  viewCount?: number;
}

export interface DigitalCardData {
  title: string;
  tags: string[];
  name: string;
  email: string;
  phone: string;
  whatsapp?: string;
  designation?: string;
  companyName?: string;
  companyAddress?: string;
  briefDescription?: string;
  website?: string;
  facebook?: string;
  instagram?: string;
  linkedIn?: string;
  googleCalendar?: string;
  profilePicture?: string;
  cardUrl?: string;
  uniqueLinkId?: string;
  _id?: string;
  organization?: string;
  type?: string;
  viewCount?: number;
}